import { Route, Routes } from 'react-router-dom';
import { Uebersicht } from './pages/uebersicht/Uebersicht';
import { KalenderUebersicht } from './pages/kalender/KalenderUebersicht';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import { CreateTermineWrapper } from '@/domain/termine/features/CreateTermin/shared/CreateTermineWrapper';
import { useProfile } from '@/hooks/useProfile';
import { NavigateToV1 } from '@/app/Routes/AuthenticatedRoutes/AuthenticatedRoutes';
import { UpdateTermineWrapper } from '@/domain/termine/features/UpdateTermin';

export function Termine() {
  const profile = useProfile();

  const rechte = profile?.manager?.rechte;

  if (rechte?.termine === false) {
    return <NavigateToV1 />;
  }

  return (
    <Routes>
      <Route
        path="/uebersicht"
        element={
          <WithFeatureFlags name="termine">
            <Uebersicht />
          </WithFeatureFlags>
        }
      />
      <Route
        path="/uebersicht/:year/:month?/:day?"
        element={
          <WithFeatureFlags name="termine">
            <Uebersicht />
          </WithFeatureFlags>
        }>
        <Route path="create" element={<CreateTermineWrapper />} />
        <Route path=":day/create" element={<CreateTermineWrapper />} />
        <Route path="edit/:id" element={<UpdateTermineWrapper />} />
      </Route>
      <Route
        path="/kalender/uebersicht"
        element={
          <WithFeatureFlags name="termine">
            <KalenderUebersicht />
          </WithFeatureFlags>
        }
      />
    </Routes>
  );
}
